import { render, staticRenderFns } from "./UserCardBasicData.vue?vue&type=template&id=3fd93e8b&scoped=true&"
import script from "./UserCardBasicData.vue?vue&type=script&lang=ts&"
export * from "./UserCardBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd93e8b",
  null
  
)

export default component.exports